import React, { createContext, useState, useEffect } from "react";
import Fuse from "fuse.js";
import axios from "axios";

const CartContext = createContext();
export default CartContext;

export function CartProvider({ children, SetLoggedIn }) {
  const UserRoles = {
    PRODUCTADMIN: 1,

    SUPERADMIN: 2,
    BUSINESSMANAGER: 3,

    ORDERS: 4,
    PACKAGING: 5,
    DELIVERY: 6,
    PAYMENT: 7,
    RETURNS: 8,
    SHIPPING: 9,

    CRMMANAGER: 10,
    CRMSALEEXECUTIVE: 11,

    PRODUCTPURCHASEMANAGER: 12,

    RAWMATERIALSINVENTORYMANAGER: 13,

    MANUFACTURINGMANAGER: 14,
    MANUFACTURINGEMPLOYEE: 15,
    MANUFACTURINGQUALITYCHECK: 16,
    MANUFACTURINGSHIPPING: 17,

    SERVICINGMANAGER: 18,
    SERVICINGBOOKING: 19,
    SERVICINGENGINEER: 20,
    SERVICINGQUALITYCHECK: 21,
    SERVICINGPAYMENT: 22,
    SERVICINGDELIVERY: 23,

    HRMANAGER: 24,
    EMPLOYEE: 25,

    ACCOUNTINGMANAGER: 26,
    ACCOUNTINGEMPLOYEE: 27,

    PROJECTMANAGER: 28,
    SUPPLIER: 29,
  };
  const DeliveryMethods = {
    INSTORE: 1,
    TAKEAWAY: 2,
    HOMEDELIVERY: 3,
    SWIGGY: 4,
    ZOMATO: 5,
  };
  const PaymentMethods = {
    CashOnDelivery: 1,
    RazorPay: 2,
    Cash: 3,
    QrCode: 4,
    CardSwipeMachine: 5,
    PayWithInvoice: 6,
    Swiggy: 7,
    Zomatto: 8,
    BankReceipt: 9,
  };

  const PaymentStates = {
    PAID: 1,
    UNPAID: 2,
  };

  const OrderStates = {
    RECEIVED: 1,
    STARTPACKAGING: 2,
    CANCELLED: 3,
    PACKAGED: 4,
    SHORTAGEITEMS: 5,
    SENTDELIVERY: 6,
    DELIVEREDANDPAID: 7,
    DELIVEREDBUTUNPAID: 8,
    PAYMENTRECEIVED: 9,
    REFUNDED: 10,
    CLOSED: 11,
    RETURNED: 12,
    ADDTOINVENTORY: 13,
    ADDEDTOINVENTORY: 14,
    CANCELPACKAGE: 15,
    CANCELDELIVERY: 16,
    CANCELLEDREFUNDNOTREQUIRED: 17,
    CANCELANDCLOSE: 18,
    REFUNDEDANDCLOSED: 19,
    RETURNEHANDEDDANDREFUNDED: 20,
  };

  const BusinessTypes = {
    GENERAL: 1,
    GROCERY: 2,
    RETAURANT: 3,
    BAKERY: 4,
    MEAT: 5,
    NURSERY: 6,
    BOOKS: 7,
    MOBILES: 8,
    ART: 9,
    JEWEL: 10,
    FASHION: 11,
    CONSTRUCTION: 12,
    FOOTWARE: 13,
    TRAVEL: 14,
    HOTELS: 15,
    MACHINERY: 16,
    MUSICSTORE: 17,
    AQUIARIUM: 18,
    STEELTRADERS: 19,
    AUDIOSTORE: 20,
  };

  const REACT_APP_VERSION = "23.10.02";
  const IsDev = false;
  const [showSideBar, setShowSideBar] = useState(true);
  const [returantTables, setReturantTables] = useState([]);
  const [selectedMenuItem, setSelectedMenuItem] = useState("");
  const [orderSummary, setOrderSummary] = useState("");
  const [storeSettings, setStoreSettings] = useState("");
  const [myCart, setMyCart] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [AddedToCartMsg, setAddedToCartMsg] = useState("");
  const [productTypes, setProductTypes] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);
  const [OrderStatus, setOrderStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [prevPage, setPrevPage] = useState("");
  const [storeId, setStoreId] = useState("");
  const [posRoles, setPosRoles] = useState([]);
  const [guestUserTypeId, setGuestUserTypeId] = useState("2");
  const [rawMaterialsInventory, setRawMaterialsInventory] = useState([]);
  const [manufacturingStatusTypes, setManufacturingStatusTypes] = useState([]);
  const [productServiceStatusTypes, setProductServiceStatusTypes] = useState(
    []
  );
  const [clientCertificates, setClientCertificates] = useState([]);
  const [clientLogos, setClientLogos] = useState([]);
  const [clientTestimonials, setClientTestimonials] = useState([]);
  const [vlogs, setVlogs] = useState([]);
  const [blogs, setBlogs] = useState([]);

  const [productServiceTasksInventory, setProductServiceTasksInventory] =
    useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [carousels, setCarousels] = useState([]);
  const [taxDetails, settaxDetails] = useState({});
  const [brands, setBrands] = useState([]);
  const [themes, setThemes] = useState([]);
  const [theme, setTheme] = useState("");
  const [productThemes, setProductThemes] = useState([]);
  const [store, setStore] = useState([]);
  const [images, setImages] = useState([]);

  const [productUnitTypes, setProductUnitTypes] = useState([]);
  const [productGroups, setProductGroups] = useState([]);
  const [productGroupsAndProducts, setProductGroupsAndProducts] = useState([]);
  const [prods, setProducts] = useState([]);
  const [prodsAll, setProductsAll] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [mainCarousel, setMainCarousel] = useState([]);
  const [mainMenus, setMainMenus] = useState([]);
  const [top5Ads, setTop5Ads] = useState([]);
  const [storeRoles, setStoreRoles] = useState([]);
  const [orderStatusTypes, setOrderStatusTypes] = useState([]);
  const [customerOrderPaymentStatusTypes, setCustomerOrderPaymentStatusTypes] =
    useState([]);
  const [restaurantTableOrdereStatus, setRestaurantTableOrdereStatus] =
    useState([]);

  const [userData, setUserData] = useState({
    emailId: "",
    bearertoken: "",
    loginStatus: "inActive", //active/inactive
    sessionId: "",
    hideSignupLink: "", //set "true" for hide; set "" for show
  });

  const hideQuotationToolbarIcon = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.QUOTATIONMANAGER == userData.roleId ||
      UserRoles.QUOTATIONEMPLOYEE == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };

  const hideOrderToolbarIcon = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.PACKAGING == userData.roleId ||
      UserRoles.SHIPPING == userData.roleId ||
      UserRoles.DELIVERY == userData.roleId ||
      UserRoles.PAYMENT == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideNewOrders = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId ||
      UserRoles.ORDERS == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideClosedOrders = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId ||
      UserRoles.ORDERS == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };

  const hidePackaingToolbarIcon = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.PACKAGING == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideShippingToolbarIcon = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.SHIPPING == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideDeliveryToolbarIcon = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.DELIVERY == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hidePaymentToolbarIcon = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.ORDERS == userData.roleId ||
      UserRoles.PAYMENT == userData.roleId ||
      UserRoles.CRMMANAGER == userData.roleId ||
      UserRoles.CRMSALEEXECUTIVE == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideReturns = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      // UserRoles.BUSINESSMANAGER == userData.roleId ||
      // UserRoles.ORDERS == userData.roleId ||
      // UserRoles.PAYMENT == userData.roleId ||
      // UserRoles.CRMMANAGER == userData.roleId ||
      // UserRoles.CRMSALEEXECUTIVE == userData.roleId ||
      UserRoles.RETURNS == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };

  const hideProductPurchases = () => {
    if (
      UserRoles.PRODUCTADMIN == userData.roleId ||
      UserRoles.SUPERADMIN == userData.roleId ||
      UserRoles.BUSINESSMANAGER == userData.roleId ||
      UserRoles.PRODUCTPURCHASEMANAGER == userData.roleId ||
      UserRoles.RAWMATERIALSINVENTORYMANAGER == userData.roleId
    ) {
      return false;
    } else {
      return true;
    }
  };

  const hideRawMaterials = () => {
    if (
      (UserRoles.PRODUCTADMIN == userData.roleId ||
        UserRoles.SUPERADMIN == userData.roleId ||
        UserRoles.BUSINESSMANAGER == userData.roleId ||
        UserRoles.PRODUCTPURCHASEMANAGER == userData.roleId ||
        UserRoles.RAWMATERIALSINVENTORYMANAGER == userData.roleId) == true
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideEmployees = () => {
    if (
      (UserRoles.PRODUCTADMIN == userData.roleId ||
        UserRoles.SUPERADMIN == userData.roleId ||
        UserRoles.BUSINESSMANAGER == userData.roleId ||
        UserRoles.HRMANAGER == userData.roleId ||
        UserRoles.EMPLOYEE == userData.roleId) == true
    ) {
      return false;
    } else {
      return true;
    }
  };
  const hideAccounting = () => {
    if (
      (UserRoles.PRODUCTADMIN == userData.roleId ||
        UserRoles.SUPERADMIN == userData.roleId ||
        UserRoles.BUSINESSMANAGER == userData.roleId ||
        UserRoles.ACCOUNTINGMANAGER == userData.roleId ||
        UserRoles.ACCOUNTINGEMPLOYEE == userData.roleId) == true
    ) {
      return false;
    } else {
      return true;
    }
  };

  const SetShowSideBar = (value) => {
    setShowSideBar(value);
  };

  const hideDeleteButtonMenu = () => {
    if (UserRoles.PRODUCTADMIN == userData.roleId) {
      return false;
    } else {
      return true;
    }
  };

  const GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsInventories/" +
        storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setRawMaterialsInventory(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const GetClientCertificates = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetClientCertificates/" +
        storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setClientCertificates(
            data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
          );
        }
      })
      .catch((error) => {});
  };

  const GetClientLogos = () => {
    fetch(process.env.REACT_APP_API + "StoreManager/GetClientLogos/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setClientLogos(data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      })
      .catch((error) => {
        // alert("GetMainMenus:: " + error);
      });
  };

  const GetClientTestimonials = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetClientTestimonials/" +
        storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setClientTestimonials(
            data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
          );
        }
      })
      .catch((error) => {});
  };
  const GetVlogs = () => {
    var res = axios
      .get(process.env.REACT_APP_API + "Consumers/GetVlogs/" + storeId)
      .then((response) => {
        if (response.status == 404) {
        } else if (response.status == 200) {
          setVlogs(response.data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      })
      .catch((error) => {
        console.error("GetCarousel - There was an error! ", error);
      });
  };
  const GetBlogs = () => {
    var res = axios
      .get(process.env.REACT_APP_API + "Consumers/GetBlogs/" + storeId)
      .then((response) => {
        if (response.status == 404) {
        } else if (response.status == 200) {
          setBlogs(response.data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      })
      .catch((error) => {
        console.error("GetCarousel - There was an error! ", error);
      });
  };

  const GetProductServiceTasksInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "ProductService/GetProductServiceTasksInventories/" +
        storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setProductServiceTasksInventory(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const [guestUserData, setGuestUserData] = useState([]);
  const StoreGuestUserData = (data) => {
    setGuestUserData(data);
  };

  const GetDefaultCurrency = () => {
    if (storeSettings.defaultCurrency == "INR") {
      return "₹";
    } else if (storeSettings.defaultCurrency == "USD") {
      return "$";
    }
  };

  const GetRestaturantTables = () => {
    fetch(
      process.env.REACT_APP_API + "Consumers/GetRestaturantTables/" + storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setReturantTables(data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      });
  };
  const storeOrderInformation = (data) => {
    setOrderData(data);
  };
  const UpdateOrderStatus = (status) => {
    setOrderStatus(status);
  };

  const UpdateSelectedMenuItem = (menuitem) => {
    setSelectedMenuItem(menuitem);
  };

  const GetCustomerOrderPaymentStatusTypes = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetCustomerOrderPaymentStatusTypes/"
    )
      .then((response) => response.json())
      .then((data) => {
        setCustomerOrderPaymentStatusTypes(data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("GetCustomerOrderPaymentStatusTypes fetch err:" + error);
      });
  };

  const getTaxDetails = () => {
    fetch(process.env.REACT_APP_API + "StoreManager/GetTaxDetails/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          settaxDetails(data);
        }
      })
      .catch((error) => {
        console.error("GetShippingDetails!", error);
      });
  };

  const GetOrdersSummary = () => {
    fetch(process.env.REACT_APP_API + "Dashboard/GetOrdersSummary/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        setOrderSummary(data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("GetOrdersSummary fetch err:" + error);
      });
  };

  const GetAllImageNames = () => {
    fetch(process.env.REACT_APP_API + "Common/GetAllImageNames/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setImages(data.sort((a, b) => (a.size < b.size ? 1 : -1)));
        }
      })
      .catch((error) => {
        // alert("GetAllImageNames:: " + error);
      });
  };

  const GetManufacturingStatusTypes = () => {
    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/GetManufacturingStatusTypes/" +
        storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setManufacturingStatusTypes(data);
      })
      .catch((error) => {
        // alert("GetProductGroups:: " + error);
      });
  };
  const GetProductServiceStatusTypes = () => {
    fetch(
      process.env.REACT_APP_API +
        "ProductService/GetProductServiceStatusTypes/" +
        storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setProductServiceStatusTypes(data);
      })
      .catch((error) => {
        // alert("GetProductGroups:: " + error);
      });
  };

  const GetProductGroups = () => {
    fetch(
      process.env.REACT_APP_API + "StoreManager/GetProductGroups/" + storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setProductGroups(data);
      })
      .catch((error) => {
        // alert("GetProductGroups:: " + error);
      });
  };

  const GetOrderStatusTypes = () => {
    var res = axios
      .get(process.env.REACT_APP_API + "StoreManager/GetOrderStatusTypes/")
      .then((response) => {
        if (response.status === 200) {
          setOrderStatusTypes(response.data);
        }
      })
      .catch((error) => {
        console.error("GetOrderStatusTypes - There was an error! ", error);
      });
  };

  const GetMainMenus = () => {
    fetch(process.env.REACT_APP_API + "Consumers/GetMainMenus/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setMainMenus(data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
      })
      .catch((error) => {
        // alert("GetMainMenus:: " + error);
      });
  };
  const GetTop5Ads = () => {
    fetch(process.env.REACT_APP_API + "Consumers/GetTop5Ads/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setTop5Ads(data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      })
      .catch((error) => {
        // alert("GetMainMenus:: " + error);
      });
  };

  const GetStoreRoles = () => {
    fetch(process.env.REACT_APP_API + "AdminUsers/GetStoreUserRoles/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setStoreRoles(data);
      })
      .catch((error) => {
        // alert("GetStoreRoles:: " + error);
      });
  };

  const GetMainCarousels = () => {
    var res = axios
      .get(process.env.REACT_APP_API + "Consumers/GetAllCarousels/" + storeId)
      .then((response) => {
        if (response.status == 404) {
        } else if (response.status == 200) {
          setCarousels(
            response.data
              .sort((a, b) => (a.seqNo < b.seqNo ? 1 : -1))
              .sort((a, b) => (a.targetDevice > b.targetDevice ? 1 : -1))
          );
        } else {
        }
      })
      .catch((error) => {
        console.error("GetCarousel - There was an error! ", error);
        // alert("Error GetCarousel:" + error);
      });
  };

  const searchOptions = {
    // isCaseSensitive: false,
    // includeScore: false,
    // shouldSort: true,
    // includeMatches: false,
    // findAllMatches: false,
    // minMatchCharLength: 1,
    // location: 0,
    // threshold: 0.6,
    // distance: 100,
    // useExtendedSearch: false,
    // ignoreLocation: false,
    // ignoreFieldNorm: false,
    // fieldNormWeight: 1,
    keys: ["title", "author.firstName"],
  };

  const getImageList = () => {
    return [
      { fileName: "" },
      { fileName: "amla.png" },
      { fileName: "Banganapalli.png" },
      { fileName: "chikku.jpg" },
      { fileName: "GuavaAlahabad.png" },
      { fileName: "GuavaTaiwan.png" },
      { fileName: "Malika.png" },
      { fileName: "GuavaTaiwan.png" },
      { fileName: "Malika.png" },
      { fileName: "Banganapalli.png" },
      { fileName: "chikku.jpg" },
      { fileName: "GuavaAlahabad.png" },
      { fileName: "GuavaTaiwan.png" },
      { fileName: "Malika.png" },
      { fileName: "Karpuravallibanana.jpg" },
      { fileName: "redbanana.png" },
      { fileName: "redlady.jpg" },
      { fileName: "BananaFlower.png" },
      { fileName: "BigOnion.png" },
      { fileName: "bitter.jpg" },
      { fileName: "beet1.png" },
      { fileName: "Broccoli.png" },
      { fileName: "cucumber.png" },
      { fileName: "GarlicNati.png" },
      { fileName: "Maravalli.png" },
      { fileName: "GreenChilli.png" },
      { fileName: "okra.jpg" },
      { fileName: "AmulCheese.jpg" },
      { fileName: "AmulGoldMilk.jpg" },
      { fileName: "AmulkMilk.jpg" },
      { fileName: "MilkyMistCurdContainer.jpg" },
      { fileName: "NandhiniMilk.jpg" },
      { fileName: "MilkyMistCheese.jpg" },
      { fileName: "IdlyPlates.jpg" },
      { fileName: "KichenRack.jpg" },
      { fileName: "SpoonContainerSteel.jpg" },
      { fileName: "SpoonContainerWood.jpg" },
      { fileName: "SteelTool.jpg" },
      { fileName: "VegCutter.jpg" },
      { fileName: "WoodenTools.jpg" },
      { fileName: "SnackCheetos.jpg" },
      { fileName: "SnackKodubale.jpg" },
      { fileName: "SnackMarieGold.jpg" },
      { fileName: "SnackMoongDal.jpg" },
      { fileName: "SnackRagiStick.jpg" },
      { fileName: "SnacPuffcorn.jpg" },
      { fileName: "AmulChocolate.jpg" },
      { fileName: "AmulCone.jpg" },
      { fileName: "AmulFruitNuts.jpg" },
      { fileName: "KuwalityMango.jpg" },
      { fileName: "ShahiAnjir.jpg" },
      { fileName: "Ashirwad.jpg" },
      { fileName: "Idayam.jpg" },
      { fileName: "Parle.jpg" },
      { fileName: "Amul.jpg" },
      { fileName: "Milky-Mist.jpg" },
    ];
  };

  const GetSearchResult = (pattenText) => {
    //setSearchData(options);
    const fuse = new Fuse(prods, searchOptions);
    setSearchData(fuse.search(pattenText));
  };

  const storePreviousPage = (value) => {
    setPrevPage(value);
  };

  const ClearCartAndOrderDetails = () => {
    setMyCart([{}]);
    localStorage.removeItem("localstoragecartitems");
    //setOrderData("");
  };

  const GetStore = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetStore/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setStore(data);
          document.title = data.name + "- Admin";
        }
      })
      .catch((error) => {
        // alert("GetStores Error:: " + error);
      });
  };

  const GetStoreSettings = () => {
    fetch(process.env.REACT_APP_API + "Consumers/GetStoreSetting/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setStoreSettings(data);
          if (data.selectedThemeType == "Product") {
            getProductTheme(data.themeName);
          } else if (data.selectedThemeType == "Custom") {
            getCustomTheme(data.customThemeName);
          }
        }
      })
      .catch((error) => {
        // this.ShowMessagBox("Warning", "Session Timeout!");
      });
  };
  const getProductTheme = (themeName) => {
    if (themeName == "") {
      alert("ThemeName is not set!");
      return;
    }
    fetch(process.env.REACT_APP_API + "Consumers/GetProductTheme/" + themeName)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setTheme(data);
        }
      })
      .catch((error) => {
        console.error("GetTheme: There was an error!", error);
      });
  };
  const getCustomTheme = (themeName) => {
    if (themeName == "") {
      alert("ThemeName is not set!");
      return;
    }
    fetch(
      process.env.REACT_APP_API +
        "Consumers/GetCustomTheme/" +
        storeId +
        "," +
        themeName
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setTheme(data);
        }
      })
      .catch((error) => {
        console.error("GetTheme: There was an error!", error);
      });
  };

  const storeUserData = (data) => {
    if (data) {
      setUserData({
        id: data.id,
        emailId: data.emailId,
        password: data.password,
        roleId: data.roleId,
        storeRoleValue: data.storeRoleValue,
        lastSignIn: data.lastSignIn,
        bearertoken: data.bearerToken,
        sessionId: data.sessionId,
        loginStatus: "active",
        hideSignupLink: "true", //set "true" for hide; set "" for show
      });
    } else {
      setUserData({
        emailId: "",
        bearertoken: "",
        loginStatus: "inActive", //active/inactive
        sessionId: "",
        hideSignupLink: "", //set "true" for hide; set "" for show
      });
    }
    setUserData((state) => {
      localStorage.setItem("localstorageUserData", JSON.stringify(state));
      return state;
    });
  };
  const clearUserData = () => {
    setUserData({
      emailId: "",
      bearertoken: "",
      loginStatus: "inActive", //active/inactive
      sessionId: "",
      hideSignupLink: "", //set "true" for hide; set "" for show
    });

    setUserData((state) => {
      //todo: enable
      localStorage.setItem(
        "localstorageUserData",
        JSON.stringify({
          emailId: "",
          bearertoken: "",
          loginStatus: "inActive", //active/inactive
          sessionId: "",
          hideSignupLink: "", //set "true" for hide; set "" for show
        })
      );
      return state;
    });
  };

  const RefreshBearerToken = (emailid, password) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        emailId: userData.emailId,
        password: userData.password,
        sessionId: userData.sessionId,
        storeId: storeId,
      }),
    };

    fetch(process.env.REACT_APP_API + "AdminUsers/Login", requestOptions)
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          storeUserData(data); // ✅ update context with new expiry
        } else {
          storeUserData(null); // force logout
        }
      })
      .catch((error) => {
        console.error("RefreshBearerToken error:", error);
      });
  };
  const getMainCategories = () => {
    setMainCategories([]);
    fetch(process.env.REACT_APP_API + "StoreManager/GetMainCategory/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setMainCategories(data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("getMainCategories err:" + error);
      });
  };
  const GetBasePrice = (prod) => {
    return Number(prod.mrp) - (Number(prod.mrp) * Number(prod.discount)) / 100;
  };
  const GetTakeAwayPrice = (prod) => {
    return (
      Number(prod.mrp) +
      (Number(prod.mrp) * Number(prod.takeAwayChargeInPercentage)) / 100 -
      ((Number(prod.mrp) +
        (Number(prod.mrp) * Number(prod.takeAwayChargeInPercentage)) / 100) *
        Number(prod.discount)) /
        100
    );
  };
  const GetHomeDeliveryPrice = (prod) => {
    return (
      Number(prod.mrp) +
      (Number(prod.mrp) * Number(prod.homeDeliveryChargeInPercentage)) / 100 -
      ((Number(prod.mrp) +
        (Number(prod.mrp) * Number(prod.homeDeliveryChargeInPercentage)) /
          100) *
        Number(prod.discount)) /
        100
    );
  };

  const getMainCategoryName = (mainCategoryId) => {
    var name = "";
    mainCategories.map((main) => {
      if (main.id == mainCategoryId) {
        console.log(main.name);
        name = main.name;
        return name;
      }
    });
    return name;
  };

  const GetPosUserRoles = () => {
    fetch(process.env.REACT_APP_API + "Common/GetPosUserRoles/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setPosRoles(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const getSubCategories = () => {
    setSubCategories([]);
    fetch(process.env.REACT_APP_API + "StoreManager/GetSubCategory/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setSubCategories(data.sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1)));
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("getSubCategories err:" + error);
      });
  };

  const getBrands = () => {
    setBrands([]);
    fetch(process.env.REACT_APP_API + "StoreManager/GetBrands/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setBrands(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const getThemes = () => {
    setThemes([]);
    fetch(process.env.REACT_APP_API + "StoreManager/GetThemes/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setThemes(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("Error GetThemes");
      });
  };
  const getProductThemes = () => {
    setProductThemes([]);
    fetch(process.env.REACT_APP_API + "StoreManager/GetProductThemes/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setProductThemes(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("Error GetProductThemes");
      });
  };

  const GetProductUnitTypes = () => {
    fetch(process.env.REACT_APP_API + "Common/GetProductUnitTypes")
      .then((response) => response.json())
      .then((data) => {
        setProductUnitTypes(data);
      })
      .catch((error) => {
        alert("GetProductUnitTypes Err:" + error);
        // console.error("There was an error!", error);
      });
  };
  const GetAllProducts = () => {
    var querystring = `?MainCategoryId=-1&SubCategoryId=-1&filtertext=-1`;
    fetch(process.env.REACT_APP_API + "StoreManager/GetProducts/" + storeId)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          if (data.length > 0) {
            var sortedProducts = data.sort((a, b) =>
              a.name > b.name ? 1 : -1
            );
            setProducts(sortedProducts);
            setProductsAll(sortedProducts);
          }
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const DeleteProductFromMemory = (productId) => {
    setProducts(prods.filter((productitem) => productId !== productitem.id));
    setProductsAll(
      prodsAll.filter((productitem) => productId !== productitem.id)
    );
  };

  const UpdateProductInContext = (product) => {
    for (var i = 0; i < prods.length; i++) {
      if (prods[i].id == product.id) {
        prods[i] = product;
        break;
      }
    }

    for (var i = 0; i < prodsAll.length; i++) {
      if (prodsAll[i].id == product.id) {
        prodsAll[i] = product;
        break;
      }
    }
  };

  const GetProductsByMainCategoryId = (MainCategoryId) => {
    var tmpProds = prodsAll;
    setProducts(
      tmpProds.filter(
        (productitem) =>
          MainCategoryId == productitem.subCategory.mainCategoryId
      )
    );
  };
  const GetProductsBySubCategoryId = (CategoryId) => {
    var tmpProds = prodsAll;
    setProducts(
      tmpProds.filter((productitem) => CategoryId == productitem.subCategoryId)
    );
  };

  //create your forceUpdate hook
  function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue((value) => value + 1); // update the state to force render
  }

  useEffect(() => {
    var v1 = localStorage.getItem("localstorageUserData");
    if (v1 !== null && v1 !== `""` && v1 !== ``) {
      var jData = JSON.parse(v1);
      setUserData(jData);
      if (jData && jData.loginStatus && jData.loginStatus == "active") {
        SetLoggedIn(true);
      }
    }
  }, []);

  const ClearAllCookies = () => {
    localStorage.setItem(
      "localstorageUserData",
      JSON.stringify({
        emailId: "",
        bearertoken: "",
        loginStatus: "inActive", //active/inactive
        sessionId: "",
        hideSignupLink: "", //set "true" for hide; set "" for show
      })
    );
  };

  const getTotalSavingsFromCart = (myCart) => {
    var totsav = 0;
    if (myCart !== null && (myCart !== `""`) & (myCart !== ``)) {
      myCart.map((item) => {
        totsav =
          totsav +
          (Number(item.prod.mrp) *
            Number(item.qty) *
            Number(item.prod.discount)) /
            100;
      });
    }
    return Number(totsav);
  };

  const getSubTotalPriceInCart = (myCart) => {
    var totprice = 0;
    if (myCart !== null && (myCart !== `""`) & (myCart !== ``)) {
      myCart.map((item) => {
        totprice =
          totprice +
          Number(item.qty) *
            (Number(item.prod.mrp) -
              (Number(item.prod.mrp) * Number(item.prod.discount)) / 100);
      });
    }
    return Number(totprice);
  };
  const getTotalQtyInCart = (myCart) => {
    var totqty = 0;
    if (myCart !== null && (myCart !== `""`) & (myCart !== ``)) {
      myCart.map((item) => {
        totqty = totqty + Number(item.qty);
      });
    }
    return totqty;
  };
  const getTotalPriceInCart = (myCart) => {
    var totprice = 0;
    if (myCart !== null && (myCart !== `""`) & (myCart !== ``)) {
      myCart.map((item) => {
        totprice = totprice + Number(item.qty) * Number(item.price);
      });
    }
    return totprice;
  };

  const GetRestaurantTableOrdereStatus = () => {
    fetch(
      process.env.REACT_APP_API + "Consumers/GetRestaurantTableOrdereStatus/"
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setRestaurantTableOrdereStatus(data);
        }
      });
  };
  const GetRestaurantTableOrdereStatusById = (statusID) => {
    return restaurantTableOrdereStatus.filter((f) => f.id == statusID)[0];
  };

  const ReturnwithDiscount = (mrp, qty, discount) => {
    return mrp * qty - (mrp * qty * discount) / 100;
  };
  const ReturnwithTax = (mrp, qty, discount, tax) => {
    return (
      ReturnwithDiscount(mrp, qty, discount) +
      (ReturnwithDiscount(mrp, qty, discount) * tax) / 100
    );
  };

  const GetTicks = (date) => {
    var currentTime = date.getTime();
    // 10,000 ticks in 1 millisecond
    // jsTicks is number of ticks from midnight Jan 1, 1970
    var jsTicks = currentTime * 10000;
    // add 621355968000000000 to jsTicks
    // netTicks is number of ticks from midnight Jan 1, 01 CE
    var netTicks = jsTicks + 621355968000000000;
    return netTicks;
  };

  const GetInDateFormat = (D) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = D.getDate();

    const monthIndex = D.getMonth();
    const monthName = monthNames[monthIndex];

    const year = D.getFullYear();

    return `${day}-${monthName}-${year}`;
  };
  const GetDateResult = (dateRange, startDate, endDate) => {
    var reportDetails = "";
    var today = new Date();
    var yday = new Date(Date.now() - 864e5);
    var threeday = new Date(Date.now() - 864e5 * 2);
    var sevenday = new Date(Date.now() - 864e5 * 6);
    if (dateRange == "Today")
      reportDetails += "Date:," + GetInDateFormat(new Date());
    if (dateRange == "Yesterday")
      reportDetails += "Date:," + GetInDateFormat(yday);
    if (dateRange == "Last 3 Days")
      reportDetails +=
        "Date Between:," +
        GetInDateFormat(threeday) +
        "," +
        GetInDateFormat(new Date());
    if (dateRange == "Last 7 Days") {
      reportDetails +=
        "Date Between:," +
        GetInDateFormat(sevenday) +
        "," +
        GetInDateFormat(new Date());
    }
    if (dateRange == "This Month") {
      reportDetails +=
        "Date:,Month of " +
        new Date().toLocaleString("default", { month: "long" });
    }
    if (dateRange == "Last Month") {
      var tdate = new Date(Date.now());
      tdate.setMonth(today.getMonth() - 1);
      let previousMonth = tdate.toLocaleString("en-US", {
        month: "long",
      });
      reportDetails += "Date: Month of," + previousMonth;
    }
    if (dateRange == "Last 3 Months") {
      var tdate = new Date(Date.now());
      tdate.setMonth(today.getMonth() - 2);
      let previousMonth = tdate.toLocaleString("en-US", {
        month: "long",
      });
      reportDetails += "Date: Month From," + previousMonth;
    }
    if (dateRange == "All") {
      reportDetails += "Date till:," + GetInDateFormat(new Date());
    }
    if (dateRange == "Custom") {
      reportDetails +=
        "Date Between:," +
        GetInDateFormat(startDate) +
        "," +
        GetInDateFormat(endDate);
    }
    return reportDetails;
  };

  const GetEcProductTypes = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetEcProductTypes")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setProductTypes(data);
      })
      .catch((error) => {});
  };
  const GetProductTypeNameById = (id) => {
    var result = productTypes.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  const GetLicenseTypeNameById = (id) => {
    var result = storeTypes.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };
  const GetStoreTypes = () => {
    fetch(process.env.REACT_APP_API + "Common/GetStoreTypes/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setStoreTypes(data);
      })
      .catch((error) => {
        alert("GetStoreTypes Error:: " + error);
      });
  };

  const presetToRange = (preset) => {
    const now = new Date();
    const startOfWeek = (d) => {
      const n = new Date(d);
      const day = n.getDay(); // 0 Sun ... 6 Sat
      const diff = (day === 0 ? -6 : 1) - day; // Monday as start
      n.setDate(n.getDate() + diff);
      n.setHours(0, 0, 0, 0);
      return n;
    };
    const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
    const startOfYear = (d) => new Date(d.getFullYear(), 0, 1);

    let from = null,
      to = null;
    switch (preset) {
      case "today":
        from = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        to = new Date(from);
        break;
      case "week":
        from = startOfWeek(now);
        to = now;
        break;
      case "month":
        from = startOfMonth(now);
        to = now;
        break;
      case "year":
        from = startOfYear(now);
        to = now;
        break;
      default:
        from = null;
        to = null;
    }
    const iso = (d) => (d ? d.toISOString().substring(0, 10) : "");
    return { from: iso(from), to: iso(to) };
  };

  const GetEpochMs = (d) => {
    if (!d) return 0; // or null, based on how backend handles it
    const dt = d instanceof Date ? d : new Date(d);
    return dt.getTime(); // milliseconds since Unix epoch
  };

  const isSteelTraders = () => {
    return store.businessTypeId == BusinessTypes.STEELTRADERS;
  };

  const updateMyCart = (cartitem) => {};

  return (
    <CartContext.Provider
      value={{
        REACT_APP_VERSION,
        IsDev,
        store,
        images,
        storeId,
        storeSettings,
        guestUserTypeId,
        searchData,
        myCart,
        mainCategories,
        subCategories,
        posRoles,
        brands,
        theme,
        themes,
        productThemes,
        productUnitTypes,
        prods,
        productGroups,
        productGroupsAndProducts,
        userData,
        paymentStatus,
        AddedToCartMsg,
        prevPage,
        orderData,
        OrderStatus,
        guestUserData,
        mainMenus,
        top5Ads,
        mainCarousel,
        orderStatusTypes,
        carousels,
        storeRoles,
        selectedMenuItem,
        orderSummary,
        customerOrderPaymentStatusTypes,
        taxDetails,
        UserRoles,
        returantTables,
        restaurantTableOrdereStatus,
        OrderStates,
        manufacturingStatusTypes,
        productServiceStatusTypes,
        rawMaterialsInventory,
        productServiceTasksInventory,
        PaymentStates,
        DeliveryMethods,
        PaymentMethods,
        clientCertificates,
        clientLogos,
        clientTestimonials,
        vlogs,
        blogs,
        showSideBar,
        BusinessTypes,
        setStoreSettings,
        GetStore,
        RefreshBearerToken,
        storeUserData,
        clearUserData,
        GetEcProductTypes,
        GetStoreSettings,
        getTotalQtyInCart,
        getTotalPriceInCart,
        GetPosUserRoles,
        getMainCategories,
        getSubCategories,
        getBrands,
        getThemes,
        getProductThemes,
        GetAllProducts,
        GetProductsByMainCategoryId,
        GetProductsBySubCategoryId,
        GetSearchResult,
        GetProductUnitTypes,
        ClearCartAndOrderDetails,
        storePreviousPage,
        StoreGuestUserData,
        UpdateOrderStatus,
        storeOrderInformation,
        getMainCategoryName,
        getImageList,
        GetMainMenus,
        GetTop5Ads,
        GetOrderStatusTypes,
        GetProductGroups,
        setStoreId,
        DeleteProductFromMemory,
        UpdateProductInContext,
        GetAllImageNames,
        GetMainCarousels,
        GetStoreRoles,
        UpdateSelectedMenuItem,
        GetOrdersSummary,
        GetCustomerOrderPaymentStatusTypes,
        getTaxDetails,
        hideOrderToolbarIcon,
        hideQuotationToolbarIcon,
        hidePackaingToolbarIcon,
        hideShippingToolbarIcon,
        hideDeliveryToolbarIcon,
        hidePaymentToolbarIcon,
        hideProductPurchases,
        hideRawMaterials,
        hideEmployees,
        hideAccounting,
        GetDefaultCurrency,
        getSubTotalPriceInCart,
        getTotalSavingsFromCart,
        GetRestaturantTables,
        GetRestaurantTableOrdereStatus,
        GetRestaurantTableOrdereStatusById,
        GetBasePrice,
        GetTakeAwayPrice,
        GetHomeDeliveryPrice,
        hideDeleteButtonMenu,
        ReturnwithDiscount,
        ReturnwithTax,
        GetTicks,
        GetInDateFormat,
        GetDateResult,
        GetManufacturingStatusTypes,
        GetRawMaterialsInventories,
        GetProductServiceStatusTypes,
        GetProductServiceTasksInventories,
        GetClientCertificates,
        GetClientLogos,
        GetClientTestimonials,
        GetVlogs,
        GetBlogs,
        GetProductTypeNameById,
        GetStoreTypes,
        GetLicenseTypeNameById,
        SetShowSideBar,
        presetToRange,
        isSteelTraders,
        hideNewOrders,
        hideClosedOrders,
        hideReturns,
        GetEpochMs,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
